import React, { Fragment, useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { approvePayroll, deletePayroll, getPayslip, listPayroll, markPayrollPaid, payrollDetail, regeneratePayrollVoucher, updatePayrollItem } from "../../../services/payroll";
import { academyusergetdetail } from "../../../services/admin";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const STATUS_BADGE  = { draft: "bg-secondary", approved: "bg-primary", paid: "bg-success" };
const MONTHS_LABEL  = ["","January","February","March","April","May","June","July","August","September","October","November","December"];

// Convert image URL to base64 for jsPDF
async function toBase64(url) {
  try {
    const res  = await fetch(url);
    const blob = await res.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  } catch {
    return null;
  }
}

export default function PayrollList() {
  const [list, setList]               = useState([]);
  const [detailShow, setDetailShow]   = useState(false);
  const [payslipShow, setPayslipShow] = useState(false);
  const [detail, setDetail]           = useState(null);
  const [payslip, setPayslip]         = useState(null);
  const [school, setSchool]           = useState({ name: "", phone: "", address: "", email: "", logoUrl: "" });
  const [editShow, setEditShow]       = useState(false);
  const [editItem, setEditItem]       = useState(null);
  const [editRows, setEditRows]       = useState([]);
  const [editPresentDays, setEditPresentDays] = useState("");

  useEffect(() => {
    loadList();
    // Fetch school details for payslip header
    academyusergetdetail(localStorage.getItem("UID")).then((res) => {
      if (res?.status) {
        const d = res.data.details;
        setSchool({
          name:    d.academy_name  || "",
          phone:   d.phone        || "",
          address: d.address      || "",
          email:   d.email        || "",
          logoUrl: d.logo ? (res.data.path + d.logo) : "",
        });
      }
    });
  }, []);

  function loadList() {
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1") temp.append("academy_id", localStorage.getItem("AAcademy") || "");
    listPayroll(temp).then((res) => { if (res?.status) setList(res.data); });
  }

  function handleView(id) {
    const temp = new FormData();
    temp.append("payroll_month_id", id);
    payrollDetail(temp).then((res) => {
      if (res?.status) { setDetail(res.data); setDetailShow(true); }
    });
  }

  function handleApprove(id) {
    Swal.fire({ text: "Approve this payroll?", icon: "question", showCancelButton: true, confirmButtonColor: "#2d4ac6", cancelButtonColor: "#6259ca", confirmButtonText: "Approve", allowOutsideClick: false })
      .then((result) => {
        if (result.isConfirmed) {
          const temp = new FormData();
          temp.append("payroll_month_id", id);
          approvePayroll(temp).then((res) => {
            if (res?.status) { toast.success(res.message); loadList(); setDetailShow(false); }
            else toast.error(res?.message);
          });
        }
      });
  }

  function handleRegenerateVoucher(id) {
    Swal.fire({ text: "Generate payment voucher for this payroll?", icon: "question", showCancelButton: true, confirmButtonColor: "#28a745", cancelButtonColor: "#6259ca", confirmButtonText: "Generate", allowOutsideClick: false })
      .then((result) => {
        if (result.isConfirmed) {
          const temp = new FormData();
          temp.append("payroll_month_id", id);
          regeneratePayrollVoucher(temp).then((res) => {
            if (res?.status) { toast.success(res.message); loadList(); }
            else toast.error(res?.message);
          });
        }
      });
  }

  function handleMarkPaid(id) {
    Swal.fire({ text: "Mark payroll as paid? This will create a payment voucher.", icon: "warning", showCancelButton: true, confirmButtonColor: "#28a745", cancelButtonColor: "#6259ca", confirmButtonText: "Mark Paid", allowOutsideClick: false })
      .then((result) => {
        if (result.isConfirmed) {
          const temp = new FormData();
          temp.append("payroll_month_id", id);
          temp.append("payment_method", "Cash");
          markPayrollPaid(temp).then((res) => {
            if (res?.status) { toast.success(res.message); loadList(); setDetailShow(false); }
            else toast.error(res?.message);
          });
        }
      });
  }

  function handleDelete(id, status) {
    Swal.fire({
      text: status === "paid"
        ? "This payroll is paid. Deleting will also void its payment voucher. Continue?"
        : "Delete this payroll? This removes all its salary records.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        deletePayroll(id).then((res) => {
          if (res?.status) { toast.success(res.message); loadList(); }
          else toast.error(res?.message || "Delete failed");
        });
      }
    });
  }

  function handlePayslip(itemId) {
    getPayslip(itemId).then((res) => {
      if (res?.status) { setPayslip(res.data); setPayslipShow(true); }
    });
  }

  function handleEdit(item) {
    setEditItem(item);
    setEditPresentDays(item.present_days);
    setEditRows(
      (item.details || []).map((d) => ({ ...d, editAmount: d.amount }))
    );
    setEditShow(true);
  }

  function handleEditSave() {
    const payload = {
      payroll_item_id: editItem.id,
      present_days:    editPresentDays,
      details:         editRows.map((r) => ({ id: r.id, amount: parseFloat(r.editAmount) || 0 })),
    };
    updatePayrollItem(payload).then((res) => {
      if (res?.status) {
        toast.success(res.message);
        setEditShow(false);
        // Refresh detail view
        const temp = new FormData();
        temp.append("payroll_month_id", detail.id);
        payrollDetail(temp).then((r) => { if (r?.status) setDetail(r.data); });
      } else {
        toast.error(res?.message || "Update failed");
      }
    });
  }

  async function printPayslip() {
    if (!payslip) return;

    const doc       = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
    const pageW     = doc.internal.pageSize.getWidth();
    const month     = `${MONTHS_LABEL[payslip.payroll_month?.month]} ${payslip.payroll_month?.year}`;
    const primaryColor = [45, 74, 198];

    // ── Header bar ───────────────────────────────────────────
    doc.setFillColor(...primaryColor);
    doc.rect(0, 0, pageW, 30, "F");

    // Logo
    if (school.logoUrl) {
      const base64 = await toBase64(school.logoUrl);
      if (base64) {
        try { doc.addImage(base64, "PNG", 8, 4, 22, 22); } catch {}
      }
    }

    // School name + contact in header
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(15);
    doc.setFont(undefined, "bold");
    doc.text(school.name || "School Name", 34, 13);
    doc.setFontSize(8);
    doc.setFont(undefined, "normal");
    if (school.address) doc.text(school.address, 34, 19, { maxWidth: pageW - 50 });
    if (school.phone)   doc.text(`Ph: ${school.phone}`, 34, 25);

    // PAYSLIP label on right
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");
    doc.text("PAYSLIP", pageW - 10, 18, { align: "right" });

    // ── Month title bar ──────────────────────────────────────
    doc.setFillColor(240, 243, 255);
    doc.rect(0, 30, pageW, 10, "F");
    doc.setTextColor(...primaryColor);
    doc.setFontSize(10);
    doc.setFont(undefined, "bold");
    doc.text(`Salary for the month of ${month}`, pageW / 2, 37, { align: "center" });

    // ── Employee details ─────────────────────────────────────
    doc.setTextColor(40, 40, 40);
    doc.setFontSize(9);

    const leftX  = 14;
    const rightX = pageW / 2 + 5;
    let   y      = 48;

    const empDetails = [
      ["Employee Name",  payslip.employee_name  || ""],
      ["Employee Code",  payslip.employee_code  || ""],
      ["Employee Type",  payslip.employee_type  ? payslip.employee_type.charAt(0).toUpperCase() + payslip.employee_type.slice(1) : ""],
      ["Payment Month",  month],
    ];
    const bankDetails = [
      ["Bank Name",      payslip.bank_name   || "—"],
      ["Account No",     payslip.bank_accno  || "—"],
      ["Working Days",   String(payslip.total_days)],
      ["Present Days",   String(payslip.present_days)],
    ];

    // Draw employee info grid
    doc.setDrawColor(220, 220, 220);
    doc.setFillColor(250, 250, 252);
    doc.rect(10, 42, pageW - 20, 28, "FD");

    empDetails.forEach(([label, value], i) => {
      const rowY = y + i * 6;
      doc.setFont(undefined, "bold");
      doc.setTextColor(80, 80, 80);
      doc.text(label + ":", leftX + 2, rowY);
      doc.setFont(undefined, "normal");
      doc.setTextColor(30, 30, 30);
      doc.text(value, leftX + 40, rowY);
    });

    bankDetails.forEach(([label, value], i) => {
      const rowY = y + i * 6;
      doc.setFont(undefined, "bold");
      doc.setTextColor(80, 80, 80);
      doc.text(label + ":", rightX + 2, rowY);
      doc.setFont(undefined, "normal");
      doc.setTextColor(30, 30, 30);
      doc.text(value, rightX + 32, rowY);
    });

    // ── Earnings / Deductions table ──────────────────────────
    const earnings   = payslip.details?.filter((d) => d.component_type === "earning")   || [];
    const deductions = payslip.details?.filter((d) => d.component_type === "deduction") || [];
    const maxRows    = Math.max(earnings.length, deductions.length);

    const tableBody = Array.from({ length: maxRows }, (_, i) => [
      earnings[i]?.component_name    || "",
      earnings[i]  ? `₹ ${parseFloat(earnings[i].amount).toFixed(2)}`   : "",
      deductions[i]?.component_name  || "",
      deductions[i] ? `₹ ${parseFloat(deductions[i].amount).toFixed(2)}` : "",
    ]);

    autoTable(doc, {
      startY: 76,
      head: [["Earnings", "Amount", "Deductions", "Amount"]],
      body: tableBody,
      foot: [[
        "Gross Salary",
        `₹ ${parseFloat(payslip.gross_salary).toFixed(2)}`,
        "Total Deductions",
        `₹ ${parseFloat(payslip.total_deductions).toFixed(2)}`,
      ]],
      headStyles: { fillColor: primaryColor, textColor: 255, fontStyle: "bold", fontSize: 9 },
      footStyles: { fillColor: [230, 235, 255], textColor: [45, 74, 198], fontStyle: "bold", fontSize: 9 },
      bodyStyles: { fontSize: 8, textColor: [40, 40, 40] },
      alternateRowStyles: { fillColor: [248, 250, 255] },
      columnStyles: {
        0: { cellWidth: (pageW - 20) / 4 },
        1: { cellWidth: (pageW - 20) / 4, halign: "right" },
        2: { cellWidth: (pageW - 20) / 4 },
        3: { cellWidth: (pageW - 20) / 4, halign: "right" },
      },
      margin: { left: 10, right: 10 },
    });

    // ── Net Salary box ────────────────────────────────────────
    const finalY = doc.lastAutoTable.finalY + 6;
    doc.setFillColor(...primaryColor);
    doc.roundedRect(10, finalY, pageW - 20, 12, 2, 2, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(11);
    doc.setFont(undefined, "bold");
    doc.text("Net Salary Payable", 16, finalY + 8);
    doc.text(`₹ ${parseFloat(payslip.net_salary).toFixed(2)}`, pageW - 16, finalY + 8, { align: "right" });

    // ── Footer ────────────────────────────────────────────────
    const footY = finalY + 30;
    doc.setTextColor(120, 120, 120);
    doc.setFontSize(7);
    doc.setFont(undefined, "normal");
    doc.text("This is a computer generated payslip and does not require a signature.", pageW / 2, footY, { align: "center" });
    doc.setDrawColor(...primaryColor);
    doc.line(10, footY - 4, pageW - 10, footY - 4);

    doc.save(`Payslip_${payslip.employee_name}_${month}.pdf`);
  }

  const columnDefs = [
    { headerName: "Month",     field: "month",  width: 110, resizable: true, cellRenderer: (p) => MONTHS_LABEL[p.value] },
    { headerName: "Year",      field: "year",   width: 90,  resizable: true },
    { headerName: "Employees", field: "items_count", width: 120, resizable: true },
    { headerName: "Status",    field: "status", width: 120, resizable: true,
      cellRenderer: (p) => <span className={`badge ${STATUS_BADGE[p.value] || "bg-secondary"}`}>{p.value}</span> },
    { headerName: "Paid Date", field: "paid_date", width: 120, resizable: true },
    {
      headerName: "Actions", field: "id", width: 190, filter: false, resizable: true,
      cellRenderer: (p) => (
        <div className="text-center">
          <a onClick={() => handleView(p.value)} className="btn-sm btn-info me-1" title="View"><i className="fa fa-eye" /></a>
          {p.data.status === "draft"    && <a onClick={() => handleApprove(p.value)} className="btn-sm btn-warning me-1" title="Approve"><i className="fa fa-check" /></a>}
          {p.data.status === "approved" && <a onClick={() => handleMarkPaid(p.value)} className="btn-sm btn-success me-1" title="Mark Paid"><i className="fa fa-money" /></a>}
          {p.data.status === "paid" && !p.data.has_voucher && (
            <a onClick={() => handleRegenerateVoucher(p.value)} className="btn-sm btn-warning me-1" title="Generate Voucher"><i className="fa fa-file-text-o" /></a>
          )}
          <a onClick={() => handleDelete(p.value, p.data.status)} className="btn-sm btn-danger" title="Delete"><i className="fa fa-trash" /></a>
        </div>
      ),
    },
  ];

  const detailColDefs = [
    { headerName: "Employee",   field: "employee_name",    resizable: true, cellStyle: { textAlign: "left" } },
    { headerName: "Code",       field: "employee_code",    width: 110, resizable: true },
    { headerName: "Type",       field: "employee_type",    width: 100, resizable: true,
      cellRenderer: (p) => <span className={`badge ${p.value === "teacher" ? "bg-primary" : "bg-info"}`}>{p.value}</span> },
    { headerName: "Days",       field: "present_days",     width: 90,  resizable: true, cellRenderer: (p) => `${p.value}/${p.data.total_days}` },
    { headerName: "Gross",      field: "gross_salary",     resizable: true, cellStyle: { textAlign: "right" }, cellRenderer: (p) => parseFloat(p.value).toFixed(2) },
    { headerName: "Deductions", field: "total_deductions", resizable: true, cellStyle: { textAlign: "right" }, cellRenderer: (p) => parseFloat(p.value).toFixed(2) },
    { headerName: "Net Salary", field: "net_salary",       resizable: true, cellStyle: { textAlign: "right" }, cellRenderer: (p) => <strong>{parseFloat(p.value).toFixed(2)}</strong> },
    { headerName: "Status",     field: "status", width: 100, resizable: true,
      cellRenderer: (p) => <span className={`badge ${STATUS_BADGE[p.value] || "bg-secondary"}`}>{p.value}</span> },
    {
      headerName: "Actions", field: "id", width: 120, filter: false, resizable: true,
      cellRenderer: (p) => (
        <div className="text-center">
          {p.data.status !== "paid" && (
            <a onClick={() => handleEdit(p.data)} className="btn-sm btn-success me-1" title="Edit">
              <i className="fa fa-edit" />
            </a>
          )}
          <a onClick={() => handlePayslip(p.value)} className="btn-sm btn-info" title="Payslip">
            <i className="fa fa-file-pdf-o" />
          </a>
        </div>
      ),
    },
  ];

  return (
    <Fragment>
      <div className="page-header reported-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">Payroll List</h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a>Payroll</a></li>
            <li className="breadcrumb-item active" aria-current="page">Payroll List</li>
          </ol>
        </div>
      </div>

      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <div className="ag-theme-alpine ag-style">
                <AgGridReact columnDefs={columnDefs} rowData={list} pagination paginationPageSize={10} suppressDragLeaveHidesColumns />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Payroll Detail Modal */}
      <Modal show={detailShow} onHide={() => setDetailShow(false)} size="xl">
        <Modal.Header>
          <h4>
            {detail && `${MONTHS_LABEL[detail.month]} ${detail.year} — Payroll`}
            <span className={`badge ms-2 ${STATUS_BADGE[detail?.status] || "bg-secondary"}`}>{detail?.status}</span>
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="ag-theme-alpine ag-style" style={{ height: "380px" }}>
            <AgGridReact columnDefs={detailColDefs} rowData={detail?.items || []} suppressDragLeaveHidesColumns />
          </div>
          <div className="mt-3 d-flex justify-content-between">
            <div>
              <strong>Total Gross:</strong> {detail?.items?.reduce((s, r) => s + parseFloat(r.gross_salary || 0), 0).toFixed(2)}
              &nbsp;&nbsp;
              <strong>Total Net:</strong> {detail?.items?.reduce((s, r) => s + parseFloat(r.net_salary || 0), 0).toFixed(2)}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {detail?.status === "draft"    && <a onClick={() => handleApprove(detail.id)} className="btn btn-primary">Approve Payroll</a>}
          {detail?.status === "approved" && <a onClick={() => handleMarkPaid(detail.id)} className="btn btn-success">Mark as Paid</a>}
          <a onClick={() => setDetailShow(false)} className="btn btn-secondary">Close</a>
        </Modal.Footer>
      </Modal>

      {/* Edit Payroll Item Modal */}
      <Modal show={editShow} onHide={() => setEditShow(false)} size="lg">
        <Modal.Header>
          <h4>Edit Payroll — {editItem?.employee_name} ({editItem?.employee_code})</h4>
        </Modal.Header>
        <Modal.Body>
          <Row className="row-sm mx-0 mb-3">
            <Col lg={4} md={6}>
              <label className="mb-2">Present Days <span className="text-danger">*</span></label>
              <input
                type="number"
                className="form-control"
                value={editPresentDays}
                min={0}
                max={editItem?.total_days}
                onChange={(e) => setEditPresentDays(e.target.value)}
              />
              <small className="text-muted">Total days: {editItem?.total_days}</small>
            </Col>
          </Row>

          <table className="table table-bordered table-sm">
            <thead style={{ backgroundColor: "#2d4ac6" }}>
              <tr>
                <th style={{ color: "#fff" }}>Component</th>
                <th style={{ color: "#fff", width: "110px" }}>Type</th>
                <th style={{ color: "#fff", width: "160px" }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {editRows.map((row, i) => (
                <tr key={i}>
                  <td>{row.component_name}</td>
                  <td>
                    <span className={`badge ${row.component_type === "earning" ? "bg-success" : "bg-danger"}`}>
                      {row.component_type}
                    </span>
                  </td>
                  <td>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={row.editAmount}
                      onChange={(e) => setEditRows((prev) =>
                        prev.map((r, idx) => idx === i ? { ...r, editAmount: e.target.value } : r)
                      )}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="fw-bold">
                <td colSpan={2}>Gross / Deductions / Net</td>
                <td>
                  {(() => {
                    const gross = editRows.filter((r) => r.component_type === "earning").reduce((s, r) => s + (parseFloat(r.editAmount) || 0), 0);
                    const dedu  = editRows.filter((r) => r.component_type === "deduction").reduce((s, r) => s + (parseFloat(r.editAmount) || 0), 0);
                    return (
                      <small>
                        <span className="text-success">{gross.toFixed(2)}</span>
                        {" − "}
                        <span className="text-danger">{dedu.toFixed(2)}</span>
                        {" = "}
                        <strong className="text-primary">{(gross - dedu).toFixed(2)}</strong>
                      </small>
                    );
                  })()}
                </td>
              </tr>
            </tfoot>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <a onClick={handleEditSave} className="btn btn-success">Save Changes</a>
          <a onClick={() => setEditShow(false)} className="btn btn-secondary">Cancel</a>
        </Modal.Footer>
      </Modal>

      {/* Payslip Preview Modal */}
      <Modal show={payslipShow} onHide={() => setPayslipShow(false)} size="lg">
        <Modal.Header>
          <h4>Payslip — {payslip?.employee_name}</h4>
        </Modal.Header>
        <Modal.Body>
          {payslip && (
            <div style={{ border: "1px solid #dee2e6", borderRadius: "6px", overflow: "hidden" }}>

              {/* Header */}
              <div style={{ background: "#2d4ac6", padding: "16px 20px", display: "flex", alignItems: "center", gap: "16px" }}>
                {school.logoUrl && (
                  <img src={school.logoUrl} alt="logo" style={{ height: "52px", width: "52px", objectFit: "contain", background: "#fff", borderRadius: "4px", padding: "2px" }}
                    onError={(e) => { e.target.style.display = "none"; }} />
                )}
                <div style={{ flex: 1 }}>
                  <div style={{ color: "#fff", fontWeight: "bold", fontSize: "16px" }}>{school.name}</div>
                  {school.address && <div style={{ color: "rgba(255,255,255,0.8)", fontSize: "11px", marginTop: "2px" }}>{school.address}</div>}
                  {school.phone   && <div style={{ color: "rgba(255,255,255,0.8)", fontSize: "11px" }}>Ph: {school.phone}</div>}
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ color: "#fff", fontWeight: "bold", fontSize: "14px", letterSpacing: "1px" }}>PAYSLIP</div>
                  <div style={{ color: "rgba(255,255,255,0.85)", fontSize: "11px" }}>
                    {MONTHS_LABEL[payslip.payroll_month?.month]} {payslip.payroll_month?.year}
                  </div>
                </div>
              </div>

              {/* Employee Info */}
              <div style={{ background: "#f0f3ff", padding: "12px 20px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "6px 20px", fontSize: "12px" }}>
                {[
                  ["Employee Name", payslip.employee_name],
                  ["Bank Name",     payslip.bank_name    || "—"],
                  ["Employee Code", payslip.employee_code],
                  ["Account No",    payslip.bank_accno   || "—"],
                  ["Employee Type", payslip.employee_type],
                  ["Working Days",  `${payslip.present_days} / ${payslip.total_days}`],
                ].map(([label, value]) => (
                  <div key={label} style={{ display: "flex", gap: "8px" }}>
                    <span style={{ color: "#555", minWidth: "110px", fontWeight: "600" }}>{label}:</span>
                    <span style={{ color: "#222" }}>{value}</span>
                  </div>
                ))}
              </div>

              {/* Earnings / Deductions */}
              <div style={{ padding: "16px 20px" }}>
                <table className="table table-bordered table-sm mb-0">
                  <thead style={{ backgroundColor: "#2d4ac6" }}>
                    <tr>
                      <th style={{ color: "#fff" }}>Earnings</th>
                      <th className="text-end" style={{ color: "#fff" }}>Amount</th>
                      <th style={{ color: "#fff" }}>Deductions</th>
                      <th className="text-end" style={{ color: "#fff" }}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      const earn = payslip.details?.filter((d) => d.component_type === "earning")   || [];
                      const dedu = payslip.details?.filter((d) => d.component_type === "deduction") || [];
                      return Array.from({ length: Math.max(earn.length, dedu.length) }, (_, i) => (
                        <tr key={i}>
                          <td>{earn[i]?.component_name || ""}</td>
                          <td className="text-end">{earn[i]  ? `₹ ${parseFloat(earn[i].amount).toFixed(2)}`   : ""}</td>
                          <td>{dedu[i]?.component_name || ""}</td>
                          <td className="text-end">{dedu[i] ? `₹ ${parseFloat(dedu[i].amount).toFixed(2)}` : ""}</td>
                        </tr>
                      ));
                    })()}
                  </tbody>
                  <tfoot>
                    <tr style={{ background: "#e8ecff" }}>
                      <td className="fw-bold" style={{ color: "#2d4ac6" }}>Gross Salary</td>
                      <td className="text-end fw-bold" style={{ color: "#2d4ac6" }}>₹ {parseFloat(payslip.gross_salary).toFixed(2)}</td>
                      <td className="fw-bold" style={{ color: "#2d4ac6" }}>Total Deductions</td>
                      <td className="text-end fw-bold" style={{ color: "#2d4ac6" }}>₹ {parseFloat(payslip.total_deductions).toFixed(2)}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              {/* Net Salary */}
              <div style={{ background: "#2d4ac6", padding: "12px 20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ color: "#fff", fontWeight: "bold", fontSize: "14px" }}>Net Salary Payable</span>
                <span style={{ color: "#fff", fontWeight: "bold", fontSize: "18px" }}>
                  ₹ {parseFloat(payslip.net_salary).toFixed(2)}
                </span>
              </div>

              {/* Footer note */}
              <div style={{ padding: "8px 20px", textAlign: "center", fontSize: "10px", color: "#888", borderTop: "1px solid #dee2e6" }}>
                This is a computer generated payslip and does not require a signature.
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <a onClick={printPayslip} className="btn btn-danger">
            <i className="fa fa-file-pdf-o me-1" /> Download PDF
          </a>
          <a onClick={() => setPayslipShow(false)} className="btn btn-secondary">Close</a>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
}
